import { BellRing, Plus, Send } from "lucide-react";
import { Badge, Button, Card } from "../components/ui";
import { DataTable } from "../components/DataTable";
import { useNotifications } from "../data/supergestor-data";

export function NotificationsPage() {
  const query = useNotifications();
  return (
    <div className="page-stack">
      <div className="notice">
        <BellRing size={20} />
        <div>
          <strong>Central multicanal</strong>
          <p>WhatsApp pela EVA, e-mail, SMS e mensagens internas com templates versionados.</p>
        </div>
      </div>
      <Card
        title="Notificações"
        description="Fila, tentativas e entrega auditada."
        action={
          <Button>
            <Plus size={16} /> Novo template
          </Button>
        }
      >
        <DataTable
          rows={query.data ?? []}
          getKey={(row) => row.id}
          columns={[
            { key: "customer", header: "Cliente", render: (row) => row.customer },
            {
              key: "channel",
              header: "Canal",
              render: (row) => <Badge tone="info">{row.channel}</Badge>,
            },
            { key: "destination", header: "Destino", render: (row) => row.destination },
            { key: "subject", header: "Mensagem", render: (row) => row.subject },
            {
              key: "status",
              header: "Status",
              render: (row) => (
                <Badge
                  tone={
                    row.status === "DELIVERED"
                      ? "success"
                      : row.status === "FAILED"
                        ? "danger"
                        : "warning"
                  }
                >
                  {row.status}
                </Badge>
              ),
            },
            { key: "attempts", header: "Tentativas", render: (row) => row.attempts },
            { key: "scheduled", header: "Agendada", render: (row) => row.scheduledAt },
          ]}
        />
        <div className="card-actions">
          <Button variant="secondary">
            <Send size={16} /> Processar fila de demonstração
          </Button>
        </div>
      </Card>
    </div>
  );
}
